import { z } from 'zod';
import { userSchema } from './user';

export enum ActionRequestType {
  INFORMATION = 'INFORMATION',
  SUPPORTING_DOCUMENTS = 'SUPPORTING_DOCUMENTS',
}

export enum ActionRequestStatus {
  REQUESTED = 'REQUESTED',
  SUBMITTED = 'SUBMITTED',
  SATISFIED = 'SATISFIED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

export const actionRequestSchema = z.object({
  id: z.string(),
  requestedBy: z.string(),
  providerID: z.string(),
  claimID: z.string(),
  createdAt: z.coerce.date(),
  parentRequestID: z.string().optional().nullable(),
  type: z.enum(Object.values(ActionRequestType)),
  status: z.enum(Object.values(ActionRequestStatus)),
  message: z.string(),
  requestedByUser: z.lazy(() => userSchema.partial()).optional(),
});
